'use strict';

var _roleTypes;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _require = require('lodash'),
    invert = _require.invert;

var _require2 = require('../../constants/mediaShuttle/roleTypes'),
    PORTAL_MEMBER = _require2.PORTAL_MEMBER,
    PORTAL_OPS_ADMIN = _require2.PORTAL_OPS_ADMIN,
    CLOUD_IT_ADMIN = _require2.CLOUD_IT_ADMIN;

var _require3 = require('../../constants/roleTypes'),
    MEDIA_SHUTTLE_MEMBER = _require3.MEDIA_SHUTTLE_MEMBER,
    MEDIA_SHUTTLE_OPS_ADMIN = _require3.MEDIA_SHUTTLE_OPS_ADMIN,
    MEDIA_SHUTTLE_IT_ADMIN = _require3.MEDIA_SHUTTLE_IT_ADMIN;

var roleTypes = (_roleTypes = {}, _defineProperty(_roleTypes, MEDIA_SHUTTLE_MEMBER, PORTAL_MEMBER), _defineProperty(_roleTypes, MEDIA_SHUTTLE_OPS_ADMIN, PORTAL_OPS_ADMIN), _defineProperty(_roleTypes, MEDIA_SHUTTLE_IT_ADMIN, CLOUD_IT_ADMIN), _roleTypes);

var mapMediaShuttleToPlatformRoleType = function mapMediaShuttleToPlatformRoleType(msRole) {
    return invert(roleTypes)[msRole];
};

var mapPlatformToMediaShuttleRoleType = function mapPlatformToMediaShuttleRoleType(platformRole) {
    return roleTypes[platformRole];
};

module.exports = {
    mapMediaShuttleToPlatformRoleType: mapMediaShuttleToPlatformRoleType,
    mapPlatformToMediaShuttleRoleType: mapPlatformToMediaShuttleRoleType
};